import { UserIcon } from '@app/components/users/UserIcon';
import { useToast } from '@app/core/notifications';
import { useRouter } from '@mi-front/core';
import { useIntl } from 'react-intl';
import { Page } from '../../../../../components/page/Page';
import { useErrorHandler } from '../../../../../core/hooks/useErrorHandler';
import { createUser } from '../../../api';
import { UsersBreadcrumbs } from '../components/UsersBreadcrumbs';
import { CreateUserForm } from './CreateUserForm';
import { UsersAddValues } from './createUserForm.schema';

export const CreateUserPage = () => {
  const { formatMessage } = useIntl();
  const { history } = useRouter();
  const { onApiError } = useErrorHandler();
  const { notifySuccess, notifyError } = useToast();

  const title = formatMessage({
    id: 'admin.users.addScreen.title',
    defaultMessage: 'Crear usuario',
  });

  const onSubmit = async (values: UsersAddValues) => {
    try {
      const user = await createUser(values);

      notifySuccess(
        formatMessage({
          id: 'admin.users.notifications.created',
          defaultMessage: 'Usuario creado',
        }),
      );
      history.push(`/admin/users/${user.id}`);
    } catch (error) {
      if ((error as { status: number })?.status === 409) {
        notifyError(
          formatMessage({
            id: 'admin.users.form.errors.errorUserExistsNotification',
            defaultMessage: 'El usuario ya existe',
          }),
        );
      } else {
        onApiError(error);
      }
    }
  };

  return (
    <Page data-cy="users-add-screen" htmlTitle={title}>
      <Page.Header
        icon={<UserIcon />}
        title={title}
        breadcrumbs={
          <UsersBreadcrumbs
            activeText={formatMessage({
              id: 'common.actions.create',
              defaultMessage: 'Crear nuevo',
            })}
          />
        }
      />
      <Page.Content>
        <CreateUserForm onSubmit={onSubmit} />
      </Page.Content>
    </Page>
  );
};
